export const FAQ_TAGS = {
    FAQ_LIST: "getFaqList",
    FAQ_BY_ID: "getFaqById",
} as const;